;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  // scripts for community page and modules found on community pages
  eah.communityPage = (function () {
    function _getNavOffset () {
      // const mainHeight = 0 // $('.main-nav-desktop:visible').height()
      const inpageNav = $('.inpage-nav')
      let topOffset = inpageNav.height() // 0 // isNaN(mainHeight) ? 0 : parseInt(mainHeight, 10)

      const regularNav = $('.nav--desktop:visible')
      const mobileNav = $('.nav--mobile:visible')
      if (regularNav.length) {
        topOffset += parseInt(regularNav.height(), 10)
      }
      if (mobileNav.length) {
        topOffset += parseInt(mobileNav.height(), 10)
      }
      return topOffset
    }

    function _scrollTo (targetSelector, withOffset) {
      console.log('_scrollTo', targetSelector, withOffset, _getNavOffset())
      const offset = withOffset ? _getNavOffset() : 1
      $('html,body').stop().animate({ scrollTop: ($(targetSelector).offset().top - offset) }, 500)
    }

    function checkBlocks () {
      const $blocks = $('.block')
      if ($blocks.length) {
        $blocks.find('.block__subtitle').matchHeight()
      }
    }

    const initialize = function () {
      checkBlocks()

      const inPageLinks = jQuery('a[href="#showform"]')
      if (inPageLinks.length) {
        inPageLinks.on('click', function () {
          // var $navItems = $('.js-stickyNavItem');
          // console.log($navItems);
          if ($('#inpageNavAnchor').is(':visible')) {
            $('#inpageNavAnchor').trigger('click')
          } else if ($('#inpageNavForm').is(':visible')) {
            $('#inpageNavForm').trigger('click')
          }
          return false
        })
      }

      $('.js-stickyNavItem').on('click', function (e) {
        const $a = $(e.target)
        const thisID = $(this).attr('id')
        const href = $a.attr('href')

        switch (thisID) {
          case 'inpageNavAnchor':
            _scrollTo('.form-anchor', false)
            break
          case 'inpageNavForm':
            console.log('opening form modal!')
            const $form = $('#inpageNavFormPanel')
            $form.show()
            $.fancybox({
              type: 'inline',
              content: '<p></p>', // $form.html(),
              beforeShow: function () {
                // console.log('hi there')
                // $('.fancybox-inner').empty();
                const initialForm = $form.detach()
                if (initialForm.length) {
                  $('.fancybox-inner').append(initialForm)
                } else {
                  $('.fancybox-inner').append('<p>Thank you for your interest in our community. We received your request and will be in touch soon.</p>')
                }
              },
              beforeClose: function () {
                const content = $('.fancybox-inner').html()
                // console.log('closing ...', content)
                $('#inpageNavFormPanel').html(content)
              },
              autoSize: true // This is being used strictly for videos so enforce a viewing size
            })
            break
          case 'inpageNavShare':
            // check if the one clicked is the one visible, if so this is a roll-up.
            if ($('#' + thisID + 'Panel:visible').length) {
              $('#js-slidePanel').slideUp(300, function () {
                $('#js-slidePanel > div').hide()
              })
            } else {
              // check if the panel is already out.
              if ($('.inpage-nav .nav-panel .panel:visible').length) {
                $('#js-slidePanel > div').hide()
                $('#' + thisID + 'Panel').show().animate({ opacity: 1 }, 300)
              } else {
                $('#js-slidePanel').slideDown(300, function () {
                  $('#js-slidePanel > div').hide()
                  $('#' + thisID + 'Panel').show().animate({ opacity: 1 }, 300)
                })
              }
            }
            break
          case 'inpageMIRH':
            $('[data-filter-button="mirh"]').trigger('click')
            _scrollTo('#cf-controls', true)
            break
          case 'inpageNavPhone':
            window.location.href = $(this).find('a').attr('href')
            break
          case 'inpageNavLocation':
            // _scrollTo('#eahMap', true);
            _scrollTo('.map-container', false)
            break
          case 'inpageNavFloorplan':
            $('[data-filter-button="floorplans"]').trigger('click')
            _scrollTo('#cf-controls', true)
            // _scrollTo('.explore-cards', true)
            break
          default:
            console.log('where to, boss?', href, $a)
            if (href && $(href).length) {
              _scrollTo(href, true)
            }
            break
        }

        e.preventDefault()
      })

      if ($('.inpage-navc').length) {
        let navTop = $('.inpage-nav').offset().top

        const stickyNav = function () {
          const scrollTop = $(window).scrollTop()
          const windowFactor = ($(window).width() < 940 ? 2 : 3.5)
          // console.log("Window width " + $('html').width());
          // console.log("Window factor " + windowFactor);
          // console.log("Pure scrolltop " + scrollTop);
          //  console.log("Scrolltop " + (scrollTop + (22 * windowFactor)) + " vs NavTop " + navTop);
          //
          if ((scrollTop + (22 * windowFactor)) >= navTop) { // was 46
            $('.inpage-nav').addClass('floating')
            // console.log("stickied");
          } else {
            $('.inpage-nav').removeClass('floating')
            // console.log("unstickied");
          }
        }

        stickyNav()

        $(window).scroll(function () {
          stickyNav()
        })
        $(window).resize(function () {
          // Only recalculate when the nav isn't floating.
          if ($('.inpage-nav').not('.floating').length) {
            navTop = $('.inpage-nav').offset().top
            // console.log("RECALCULATE NavTop to " + navTop);
          }

          stickyNav()
        })
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.communityPage.initialize()
  })
}(jQuery, window))
